import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Col, Row, Popover, message } from 'antd';
import { Link } from 'react-router-dom';
import { AtbdTopDropdwon } from './auth-info-style';
import { QuotesIcon, InvoiceIcon, SalesIcon, LeadIcon, ContactIcon, AccountsIcon, DealIcon, CaseIcon } from '../../Icons/Icons';
// import EditNavPopup from '../../../container/dashboard/Popup/EditNavPopup'
import AddLead from '../../../container/dashboard/Pages/AddLead'
import AddContact from '../../../container/dashboard/Pages/AddContact'
import AddAccount from '../../../container/dashboard/Pages/AddAccount'
import AddDeal from '../../../container/dashboard/Pages/AddDeals'
import AddCase from '../../../container/dashboard/QISC/AddCases'
import AddQuotes from '../../../container/dashboard/QISC/QuotesAdd'
import AddSalesOrder from '../../../container/dashboard/QISC/salesOrderAdd'
import AddInvoice from '../../../container/dashboard/QISC/InvoicesAdd'

function MessageBox() {
    const localData = useSelector((state) => state.localRedux);
    const permission = localData.permissions
    const storeSubcription = localData.subcription
    const [permissions] = useState(permission.entity)
    const edit = useSelector((state) => state.edit.edit);
    const [open, setOpen] = useState(false);
    // const [confirmPopup, setConfirmPopup] = useState(false)
    const [createPage1, setCratePage1] = useState()
    const [createPage2, setCratePage2] = useState()
    const [createPage3, setCratePage3] = useState()
    const [createPage4, setCratePage4] = useState()
    const [createPage5, setCratePage5] = useState()
    const [createPage6, setCratePage6] = useState()
    const [createPage7, setCratePage7] = useState()
    const [createPage8, setCratePage8] = useState()

    // const [linkUrl, setLinkUrl] = useState()
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const handleOpenChange = (newOpen, page) => {
        if (storeSubcription?.isActive) {
            setOpen(newOpen);
            if (edit && newOpen === false) {
                message.info("Action rejeted. you are in edit mode")
                // setConfirmPopup(true)
                // setLinkUrl(page)
            }
            else {
                const openPage = page;
                if (openPage === "Lead") {
                    setCratePage1("ListingLead")
                }
                if (openPage === "Contact") {
                    setCratePage2("ListingLead")
                }
                if (openPage === "Account") {
                    setCratePage3("ListingLead")
                }
                if (openPage === "Deal") {
                    setCratePage4("ListingDealCreate")
                }
                if (openPage === "Case") {
                    setCratePage5("ListingLead")
                }
                if (openPage === "Quote") {
                    setCratePage6("ListingLead")
                }
                if (openPage === "Orders") {
                    setCratePage7("ListingLead")
                }
                if (openPage === "Invoice") {
                    setCratePage8("ListingLead")
                }
            }
        }
        else {
            message.info("Your subscription is not active. Please renew to continue");
        }
    };
    const canCreate = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        return hasRolePermission;
    };
    const content = (
        <AtbdTopDropdwon className="atbd-top-dropdwon shortcut-style">
            <p>RECORDS</p>
            <Row>
                <Col span={6} className='shortcut-style-icons'>
                    <Link to={combinedUrl} onClick={canCreate(permissions, 2002) ? () => handleOpenChange(false, "Lead") : undefined} >
                        <LeadIcon height={24} width={24} />
                    </Link>
                    <Link to={combinedUrl} onClick={canCreate(permissions, 2002) ? () => handleOpenChange(false, "Lead") : undefined}>
                        <span>Add Lead</span>
                    </Link>
                </Col>
                <Col span={6} className='shortcut-style-icons' >
                    <Link to={combinedUrl} onClick={canCreate(permissions, 2006) ? () => handleOpenChange(false, "Contact") : undefined}>
                        <ContactIcon height={24} width={24} />
                    </Link>
                    <Link to={combinedUrl} onClick={canCreate(permissions, 2006) ? () => handleOpenChange(false, "Contact") : undefined}>
                        <span>Add Contact</span>
                    </Link>
                </Col>
                <Col span={6} className='shortcut-style-icons'>
                    <Link to={combinedUrl} onClick={canCreate(permissions, 2010) ? () => handleOpenChange(false, "Account") : undefined}>
                        <AccountsIcon height={24} width={24} />
                    </Link>
                    <Link to={combinedUrl} onClick={canCreate(permissions, 2010) ? () => handleOpenChange(false, "Account") : undefined}>
                        <span>Add Account</span>
                    </Link >
                </Col >
                <Col span={6} className='shortcut-style-icons'>
                    <Link to={combinedUrl} onClick={canCreate(permissions, 2014) ? () => handleOpenChange(false, "Deal") : undefined}>
                        <DealIcon height={24} width={24} />
                    </Link>
                    <Link to={combinedUrl} onClick={canCreate(permissions, 2014) ? () => handleOpenChange(false, "Deal") : undefined}>
                        <span>Add Deal</span>
                    </Link>
                </Col >
                {/* <Col span={6} className='shortcut-style-icons'>
                    <Link to={!edit ? "/Home/add-task" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/add-task")}>
                        <FileOutlined className='icon_size' />
                    </Link>
                    <Link to={!edit ? "/Home/add-task" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/add-task")}>
                        <span>Add Task</span>
                    </Link>
                </Col> */}
                {/* <Col span={6} className='shortcut-style-icons'>
                    <Link to={!edit ? "/Home/meetings" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/meetings")}>
                        <CalendarOutlined className='icon_size' />
                    </Link>
                    <Link to={!edit ? "/Home/meetings" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/meetings")}>
                        <span>Schedule Meeting</span>
                    </Link>
                </Col> */}
                <Col span={6} className='shortcut-style-icons'>
                    <Link to={combinedUrl} onClick={() => handleOpenChange(false, "Case")} >
                        <CaseIcon height={24} width={24} />
                    </Link>
                    <Link to={combinedUrl} onClick={() => handleOpenChange(false, "Case")}>
                        <span>Create Case</span>
                    </Link>
                </Col>
                <Col span={6} className='shortcut-style-icons'>
                    <Link to={combinedUrl} onClick={() => handleOpenChange(false, "Quote")} >
                        <QuotesIcon height={24} width={24} />
                    </Link>
                    <Link to={combinedUrl} onClick={() => handleOpenChange(false, "Quote")}>
                        <span>Create Quote</span>
                    </Link>
                </Col>
                <Col span={6} className='shortcut-style-icons'>
                    <Link to={combinedUrl} onClick={() => handleOpenChange(false, "Orders")} >
                        <SalesIcon height={24} width={24} />
                    </Link>
                    <Link to={combinedUrl} onClick={() => handleOpenChange(false, "Orders")}>
                        <span>Create Sales Order</span>
                    </Link>
                </Col>
                <Col span={6} className='shortcut-style-icons'>
                    <Link to={combinedUrl} onClick={() => handleOpenChange(false, "Invoice")} >
                        <InvoiceIcon height={24} width={24} />
                    </Link>
                    <Link to={combinedUrl} onClick={() => handleOpenChange(false, "Invoice")}>
                        <span>Create Invoice</span>
                    </Link>
                </Col>
            </Row >

            {/* {Role === "Administrator" && <>
                <p>ACTIVITY</p>
                <Row>
                    <Col span={6} className='shortcut-style-icons'>
                        <Link to={!edit ? "/Home/company" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/company")}>
                            <FeatherIcon icon="briefcase" />
                        </Link>
                        <Link to={!edit ? "/Home/company" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/company")}>
                            <span>Company</span>
                        </Link>
                    </Col>
                    <Col span={6} className='shortcut-style-icons'>
                        <Link to={!edit ? "/Home/company-roles" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/company-roles")}>
                            <FeatherIcon icon="git-merge" />
                        </Link>
                        <Link to={!edit ? "/Home/company-roles" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/company-roles")}>
                            <span>C Role</span>
                        </Link>
                    </Col>
                    <Col span={6} className='shortcut-style-icons'>
                        <Link to={!edit ? "/Home/role" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/role")}>
                            <FeatherIcon icon="server" />
                        </Link>
                        <Link to={!edit ? "/Home/role" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/role")}>
                            <span>System Roles</span>
                        </Link>
                    </Col>
                    <Col span={6} className='shortcut-style-icons'>
                        <Link to={!edit ? '/Home/groups' : combinedUrl} onClick={() => handleOpenChange(false, '/Home/groups')}>
                            <FeatherIcon icon="globe" />
                        </Link>
                        <Link to={!edit ? '/Home/groups' : combinedUrl} onClick={() => handleOpenChange(false, '/Home/groups')}>
                            <span>Groups</span>
                        </Link>
                    </Col>
                    <Col span={6} className='shortcut-style-icons'>
                        <Link to={!edit ? '/Home/users' : combinedUrl} onClick={() => handleOpenChange(false, '/Home/users')}>
                            <FeatherIcon icon="users" />
                        </Link>
                        <Link to={!edit ? '/Home/users' : combinedUrl} onClick={() => handleOpenChange(false, '/Home/users')}>
                            <span>Users</span>
                        </Link>
                    </Col>
                    <Col span={6} className='shortcut-style-icons'>
                        <Link to={!edit ? "/Home/users-history" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/users-history")}>
                            <FeatherIcon icon="inbox" />
                        </Link>
                        <Link to={!edit ? "/Home/users-history" : combinedUrl} onClick={() => handleOpenChange(false, "/Home/users-history")}>
                            <span>User Login H</span>
                        </Link>
                    </Col>
                </Row>
            </>} */}
        </AtbdTopDropdwon >
    );
    // const CallBack = (value) => {
    //     if (value === "Lead") {
    //         setCratePage1("ListingLead")
    //     }
    //     if (value === "Contact") {
    //         setCratePage2("ListingLead")
    //     }
    //     if (value === "Account") {
    //         setCratePage3("ListingLead")
    //     }
    //     if (value === "Deal") {
    //         setCratePage4("ListingDealCreate")
    //     }
    //     if (value === "Case") {
    //         setCratePage5("ListingLead")
    //     }
    //     if (value === "Quote") {
    //         setCratePage6("ListingLead")
    //     }
    //     if (value === "Orders") {
    //         setCratePage7("ListingLead")
    //     }
    //     if (value === "Invoice") {
    //         setCratePage8("ListingLead")
    //     }
    // }
    return (
        <>
            <div className="message" title='Quick Create'>
                {edit ? <span className="head-example" style={{ cursor: "not-allowed" }}>
                    <FeatherIcon icon="plus-circle" size={20} />
                </span> :
                    <Popover
                        placement="bottomLeft"
                        content={content}
                        trigger="click"
                        open={open}
                        onOpenChange={handleOpenChange}
                    >
                        <span className="head-example" style={{ cursor: "pointer" }}>
                            <FeatherIcon icon="plus-circle" size={20} />
                        </span>
                    </Popover>}
            </div>
            {/* {confirmPopup && <EditNavPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} linkUrl={linkUrl} page="Shortcut" CallBack={CallBack} />} */}

            <AddLead UrlId={undefined} FromPage={createPage1} setCratePage={setCratePage1} ShortCut="Shortcut" />
            <AddContact UrlId={undefined} FromPage={createPage2} setCratePage={setCratePage2} ShortCut="Shortcut" />
            <AddAccount UrlId={undefined} FromPage={createPage3} setCratePage={setCratePage3} ShortCut="Shortcut" />
            <AddDeal UrlId={undefined} FromPage={createPage4} setCratePage={setCratePage4} ShortCut="Shortcut" />
            <AddCase UrlId={undefined} FromPage={createPage5} setCratePage={setCratePage5} ShortCut="Shortcut" />
            <AddQuotes UrlId={undefined} FromPage={createPage6} setCratePage={setCratePage6} ShortCut="Shortcut" />
            <AddSalesOrder UrlId={undefined} FromPage={createPage7} setCratePage={setCratePage7} ShortCut="Shortcut" />
            <AddInvoice UrlId={undefined} FromPage={createPage8} setCratePage={setCratePage8} ShortCut="Shortcut" />
        </>
    );
}


export default MessageBox;
